export default class Popup {
	constructor(element) {
		this.element = element;
		this.overlay = element.querySelector(".popup-overlay");
		this.closeButton = element.querySelector(".btn-close");

		if (this.closeButton) {
			this.closeButton.addEventListener("click", e => {
				e.preventDefault();
				this.close();
			});
		}

		this.overlay.addEventListener("click", e => {
			if (e.target.isSameNode(this.overlay)) {
				this.close();
			}
		});
	}

	open() {
		this.element.classList.add("is-visible");
	}

	close() {
		this.overlay.addEventListener(
			"transitionend",
			() => this.element.classList.remove("is-hiding"),
			{ once: true }
		);

		this.element.classList.add("is-hiding");
		this.element.classList.remove("is-visible");
	}
}
